export const SET_CHECK_RESET_PM_PASSWORD_LOADING = 'SET_CHECK_RESET_PM_PASSWORD_LOADING'
export const SET_RESETTING_PM = 'SET_RESETTING_PM'
